"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routing = void 0;
const router_1 = require("@angular/router");
//EXTERNAL LIBRARY BITS
const auth_guard_service_1 = require("./auth-guard.service");
//INTERNAL LIBRARY BITS
const list_component_1 = require("./list.component");
const bidder_component_1 = require("./bidder.component");
const login_component_1 = require("./login.component");
const onboard_component_1 = require("./onboard.component");
const control_center_metrics_component_1 = require("./control-center-metrics.component");
const admin_component_1 = require("./admin.component");
const loading_component_1 = require("./loading.component");
const forgot_password_component_1 = require("./forgot-password.component");
const reset_password_component_1 = require("./reset-password.component");
const dashboard_component_1 = require("./dashboard.component");
const portal_component_1 = require("./portal.component");
const welcome_component_1 = require("./welcome.component");
const can_deactivate_guard_service_1 = require("./can-deactivate-guard.service");
const test_line_automation_component_1 = require("./test-line-automation.component");
const queue_manager_component_1 = require("./queue-manager.component");
const user_settings_component_1 = require("./user-settings.component");
const adjustment_component_1 = require("./adjustment.component");
const bidder_adUnits_resolver_1 = require("./bidder-adUnits.resolver");
const edit_bidder_resolver_1 = require("./edit-bidder.resolver");
const appRoutes = [
    {
        path: 'emx-digital-google-ob-cta',
        component: onboard_component_1.OnboardComponent
    },
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        component: login_component_1.LoginComponent
    },
    {
        path: 'portal',
        component: portal_component_1.PortalComponent,
        canActivate: [auth_guard_service_1.AuthGuard]
    },
    {
        path: 'controlcenter/list',
        component: list_component_1.ListComponent,
        canActivate: [auth_guard_service_1.AuthGuard]
    },
    {
        path: 'controlcenter/new',
        component: bidder_component_1.EditBidderComponent,
        canActivate: [auth_guard_service_1.AuthGuard],
        canDeactivate: [can_deactivate_guard_service_1.CanDeactivateGuardService]
    },
    {
        path: 'controlcenter/edit/:id',
        component: bidder_component_1.EditBidderComponent,
        canActivate: [auth_guard_service_1.AuthGuard],
        resolve: { editBidderData: edit_bidder_resolver_1.EditBidderResolver },
        canDeactivate: [can_deactivate_guard_service_1.CanDeactivateGuardService]
    },
    {
        path: 'controlcenter/copy',
        component: bidder_component_1.EditBidderComponent,
        canActivate: [auth_guard_service_1.AuthGuard],
        resolve: { editBidderData: edit_bidder_resolver_1.EditBidderResolver },
        canDeactivate: [can_deactivate_guard_service_1.CanDeactivateGuardService]
    },
    {
        path: 'dashboard/main',
        component: dashboard_component_1.DashboardComponent,
        resolve: { bidderAdUnits: bidder_adUnits_resolver_1.BidderAdUnitsResolver },
        canActivate: [auth_guard_service_1.AuthGuard]
    },
    {
        path: 'metrics/control-center',
        component: control_center_metrics_component_1.ControlCenterMetricsComponent,
        canActivate: [auth_guard_service_1.AuthGuard]
    },
    {
        path: 'admin',
        component: admin_component_1.AdminComponent,
        canActivate: [auth_guard_service_1.AuthGuard]
    },
    {
        path: 'user',
        component: user_settings_component_1.UserSettingsComponent,
        canActivate: [auth_guard_service_1.AuthGuard]
    },
    {
        path: 'welcome',
        component: welcome_component_1.WelcomeComponent,
        canActivate: [auth_guard_service_1.AuthGuard]
    },
    {
        path: 'refresh',
        component: loading_component_1.LoadingComponent,
        canActivate: [auth_guard_service_1.AuthGuard]
    },
    {
        path: 'forgotpassword',
        component: forgot_password_component_1.ForgotPasswordComponent,
    },
    {
        path: 'resetpassword/:token',
        component: reset_password_component_1.ResetPasswordComponent
    },
    {
        path: 'queue',
        component: queue_manager_component_1.QueueManagerComponent,
        canActivate: [auth_guard_service_1.AuthGuard]
    },
    {
        path: 'helm',
        component: adjustment_component_1.AdjustmentComponent,
        canActivate: [auth_guard_service_1.AuthGuard]
    },
    //Temp route. Just used to Demo LineAutomationService
    {
        path: 'liatest',
        component: test_line_automation_component_1.TestLineItemAutomationComponent,
        canActivate: [auth_guard_service_1.AuthGuard]
    }
];
exports.routing = router_1.RouterModule.forRoot(appRoutes);
//# sourceMappingURL=app.routing.js.map